import { Icon } from '@components/Elements/Icon'
import { Pressable } from '@components/Elements/Pressable'
import { Text } from '@components/Elements/Text'
import { useNavigation } from '@react-navigation/native'
import { useTasksStore } from '@stores/tasks'
import { Colors } from '@vetahealth/fishing-gear/colors'
import dayjs from 'dayjs'
import React from 'react'
import styled, { useTheme } from 'styled-components/native'
import { RouteName } from '../../router/routeNames'

const Wrapper = styled.View`
  padding: 0 ${({ theme }) => (theme.width > 360 ? 20 : 10)}px 0px;
  gap: 10px;
`
const TaskWrapper = styled.View`
  flex-direction: row-reverse;
  padding: 15px 20px;
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  border-radius: ${({ theme }) => theme.borderRadius.large}px;
  gap: 15px;
`
const InfoWrapper = styled.View`
  flex: 1;
  justify-content: center;
  padding-right: 10px;
`
const IconWrapper = styled.View`
  padding: 5px;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  border-radius: ${({ theme }) => theme.borderRadius.medium}px;
`

export function AnsweredTasks(): React.ReactNode {
  const theme = useTheme()
  const navigation = useNavigation()
  const [answeredTasks] = useTasksStore((state) => [state.answeredTasks])

  return (
    <Wrapper>
      {answeredTasks?.map((task) => {
        const isSurvey = task.details.length

        return (
          <Pressable
            key={task.responseId}
            onPress={() =>
              navigation.navigate(RouteName.AnsweredTask, {
                responseId: task.responseId,
                timestamp: task.timestamp,
              })
            }
            render={() => (
              <TaskWrapper>
                <IconWrapper>
                  <Icon
                    icon={['fad', isSurvey ? 'tasks' : 'books-medical']}
                    size={isSurvey ? 24 : 26}
                    color={isSurvey ? theme.colors.primary : Colors.mint400}
                  />
                </IconWrapper>
                <InfoWrapper>
                  <Text weight="semiBold" size="settings">
                    {task.title}
                  </Text>
                  <Text size="tiny" margins={{ top: 2 }} weight="semiBold" color={theme.colors.primaryButtonText}>
                    {dayjs(task.timestamp).format('LLL')}
                  </Text>
                </InfoWrapper>
              </TaskWrapper>
            )}
          />
        )
      })}
    </Wrapper>
  )
}
